
import { notificationsMixin } from '../../mixins'

export default {
  mixins: [notificationsMixin],
  props: {
    songs: {
      default: () => [],
      type: Array,
    },
    songsPerColumn: {
      default: null,
      type: [Number, String],
    },
    title: {
      default: null,
      type: String,
    },
    notificationsTag: {
      type: String,
      default: null,
    },
  },
  computed: {
    columns () {
      // Return user input of number of columns
      // Or calculate nr columns with a max of 6 rows
      return this.songsPerColumn || Math.min(Math.ceil(this.songs?.length / 4), 6)
    },
    isSubscribed () {
      if (!this.notificationsTag) return false
      return this.notificationSubscriptions.includes(this.notificationsTag)
    },
  },
}
